import { useCallback } from 'react';
import { ContentWrapper } from '@/components/ContentWrapper';
import { EmployeesOverview, ViewType } from './list/EmployeesOverview';
import { Stack } from '@mui/material';
import { PageHeading, PageSubHeading, SMBold } from '@/typography/Typography';
import Chip, { chipColors } from '@/components/shared/Chip';
import { useGetEmployees } from '@/services/paymentsQuery';

export const UsersPage = () => {
    const { data: usersDetails } = useGetEmployees({ limit: 16 });

    const renderPageHeading = useCallback((total?: number) => {
        return (
            <Stack direction={'row'} alignItems={'center'}>
                <PageHeading mr={1}>Employees</PageHeading>{' '}
                <Chip
                    color={'success'}
                    label={
                        <SMBold color={chipColors.success.text}>{total}</SMBold>
                    }
                />
            </Stack>
        );
    }, []);

    return (
        <ContentWrapper>
            <>
                {renderPageHeading(usersDetails?.data?.total)}
                <PageSubHeading>
                    Get an overview of the employees within your organization
                </PageSubHeading>
                <EmployeesOverview viewType={ViewType.Normal} />
            </>
        </ContentWrapper>
    );
};
